__turbopack_context__.v({
  "parent_link": "DsYWya_parent_link",
  "search_web_thumbnail": "DsYWya_search_web_thumbnail",
  "search_web_thumbnail__container": "DsYWya_search_web_thumbnail__container",
  "search_web_thumbnail__description": "DsYWya_search_web_thumbnail__description",
  "search_web_thumbnail__fallback_link": "DsYWya_search_web_thumbnail__fallback_link",
  "search_web_thumbnail__image": "DsYWya_search_web_thumbnail__image",
  "search_web_thumbnail__link": "DsYWya_search_web_thumbnail__link",
  "search_web_thumbnail__title": "DsYWya_search_web_thumbnail__title",
  "video_detail_thumbnail": "DsYWya_video_detail_thumbnail",
});
